module.exports = __webpack_public_path__ + "img/two1Green.eed8ecea.jpg";